import { Alert, Container, Skeleton } from "@mui/material";
import { useEffect, useState } from "react";
import Spacebox from "../../components/Spacebox";
import Mode from "../../components/styles/Mode";
import string from "../../utilities/Strings";
import Grid from "../../components/Grid";
import Button from "../../components/Button";
import { useDispatch, useSelector } from "react-redux";
import cookies from "../../utilities/Cookies";
import { updatedarkmode } from "../../features/mode";
import requests from "../../handlers/requests";
import { Waveform } from "@uiball/loaders";
import Flexbox from "../../components/Flexbox";
import '../../css/form.css'
import BuyerATYP from "../BuyerATYP";
import BuyerBnCTYP from "../BuyerBnCTYP";
import { useNavigate } from 'react-router-dom'
import AddressAutocomplete from "../../components/Autocomplete";
import MetaPixel from "../../components/scripts/MetaPixel";
import { BuyersTYUrl, extractUTMParameters, isPlausibleHumanName, isValidEmail, isValidUSPhoneNumber, saveTrustedFormCert } from "../../utilities/utils";
import NoticeText from "../../components/NoticeText";

let arrayTrial = 0

const FormPageNVSL = () => {

    const dispatch = useDispatch()
    const mode = useSelector(state => state.darkmode.value)

    const navigate = useNavigate()


    const [contactId, setContactId] = useState(null)
    const [trustedCertUrl, setTrustedCertUrl] = useState(null)
    const [firstname, setFirstname] = useState(null)

    const [, setOpen] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [, setToastMsg] = useState('');
    const [loading, setLoading] = useState(false);

    const [step,] = useState(1)
    const [showFirstAndLastName, setShowFirstAndLastName] = useState(false)

    const [trial, setTrial] = useState(1)

    const [showError, setShowError] = useState(null)

    const [first_name, setFirst_Name] = useState('')
    const [last_name, setLast_Name] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')

    const [state, setState] = useState('')
    const [city, setCity] = useState('')

    const [inputAddress, setInputAddress] = useState("")
    const [address, setAddress] = useState('')
    const [day, setDay] = useState('')
    const [zipcode, setZipcode] = useState('')
    const [month, setMonth] = useState('')
    const [year, setYear] = useState('')


    const [user,] = useState(null)
    const [redirectUrl,] = useState('')

    const [maxYear,] = useState((new Date()).getFullYear() - 18)

    const loading_texts = [
        'Pull Credit',
        'Reviewing your credit',
        'Evaluating options',
        'Selecting the best options'
    ]


    const scrollToTop = () => window.scrollTo({ behavior: 'smooth', top: 0 })

    const errorAlert = (msg) => {
        setShowError(msg)
        setTimeout(() => {
            setShowError(null)
        }, 4000);
    }

    const handleChange = (event, setState) => {
        setState(event.target.value)
    }

    const handleBlur = (state, setState, max) => {
        const value = state
        if (!isNaN(parseFloat(value))) {
            let num = parseFloat(value)
            if (max >= num) {
                if (num > 0 && num < 10)
                    setState(`0${num}`)
                else
                    setState(`${num}`)
            } else {
                setState('')
            }
        }
    };


    const productOffer = () => {
        if (showFirstAndLastName) {
            if (!isPlausibleHumanName(first_name) || !isPlausibleHumanName(last_name) || !isValidEmail(email) || !isValidUSPhoneNumber(phone)) {
                errorAlert('We are unable to process your data. Please check the infomation below is correct and resubmit.')
                scrollToTop()
                return
            }
        }

        if (month !== '' && day !== '' && year !== '' && zipcode !== '') {

            setLoading(true)
            setSeverity('success')

            if (showFirstAndLastName) {
                if (!checkForEmailNPass().success) {
                    setShowError(checkForEmailNPass().msg)
                    setLoading(false)
                    scrollToTop()
                    return
                }
            }

            const body = showFirstAndLastName ? { first_name: first_name, last_name: last_name, email, phone, address: address === '' ? inputAddress : address, dob: `${year}-${month}-${day}`, contact_id: contactId, zipcode, trusted_form_cert_url: trustedCertUrl, state, city } : { address: address === '' ? inputAddress : address, dob: `${year}-${month}-${day}`, contact_id: contactId, zipcode, trusted_form_cert_url: trustedCertUrl, state, city }

            if (trial > 2) {
                // if trial is over 2 times send to lead buyers
                sendToBuyers(body)
                return
            }

            const params = 'page=nvsl' + extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid'])

            // DATA LAYER
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "Add_to_cart",
                url: window.location.href
            });

            requests.post('/api/array/product-offer', { ...body, url_params: params }, setOpen, setSeverity, setToastMsg, setLoading,
                (res) => {
                    console.log('success')
                    console.log(res)
                    const temp = res.data

                    // get buyer ty page url
                    const ty_page = BuyersTYUrl.get(res.buyer) // https://www.finaldebt.com/success-valid-[buyer]- |  https://www.finaldebt.com/success-[buyer]-

                    if (res.url) {
                        if (res.url.includes('lead-array')) {
                            navigate(res.url + `&${params}`, { replace: true })
                            return
                        }
                    }

                    const full_url = `${ty_page}nvsl1?first_name=${temp.first_name}&last_name=${temp.last_name}&debt_amount=${temp.debt_amount}&phone=${temp.phone}&email=${temp.email}&zip=${temp.zipcode}&url=${res.url ?? ''}${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid'])}`

                    window.location.replace(full_url)
                },
                null,
                (res) => {
                    console.log(res.msg)

                    if (res.msg.includes('DNC'))
                        return window.location.replace(`https://www.finaldebtrelief.com/dq-nvsl1?first_name=${res.data.first_name}&last_name=${res.data.last_name}${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid'])}`)

                    if (res.msg === 'under 10k')
                        return window.location.replace(`https://www.finaldebtrelief.com/ddq-nvsl1?first_name=${res.data.first_name}&last_name=${res.data.last_name}${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid'])}`)

                    if ((res.msg).toLowerCase().includes('duplicate') || (res.error).toLowerCase().includes('duplicate')) {
                        navigate(`/lead-array?contact_id=${contactId}&source=adr-duplicate&page=nvsl${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid'])}`, { replace: true })
                        return
                    }

                    if (res.msg === 'Outside Allowed Region') {
                        window.location.replace(`https://www.finaldebtrelief.com/dq-nvsl1?first_name=${res.data.first_name}&last_name=${res.data.last_name}${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid'])}`)
                        return
                    }

                    if (res.error === 'ADR error') {
                        setShowError(res.msg) // e.g invalid_us_phone
                        setShowFirstAndLastName(true)
                        setTrial(trial + 1)
                        setEmail(res.data.email)
                        setPhone(res.data.phone)
                        setFirst_Name(res.data.first_name)
                        setLast_Name(res.data.last_name)
                    }


                    if (res.error === 'Array 403') {
                        console.log('Log 1 triggered')

                        console.log('Array 403 error occured')
                        console.log('array trial at ', arrayTrial)
                        if (arrayTrial < 2) {
                            setLoading(true)
                            arrayTrial = arrayTrial + 1
                            console.log('Running product Offer in the next 2 secs')
                            setTimeout(() => {
                                console.log('Running product Offer now')
                                productOffer()
                            }, 2000);
                        } else {
                            // send user to lead buyers
                            sendToBuyers(res.data)
                        }
                    } else if (res.msg !== 'Invalid zip code' && res.msg !== 'Missing parameters' && res.msg !== 'You need to be 18 or older') {
                        console.log('Log 2 triggered')
                        setShowError('We are unable to process your data. Please check the infomation below is correct and resubmit.')
                        setShowFirstAndLastName(true)
                        setTrial(trial + 1)
                        setEmail(res.data.email)
                        setPhone(res.data.phone)
                        setFirst_Name(res.data.first_name)
                        setLast_Name(res.data.last_name)
                    }

                    if (res.error !== 'Array 403') {
                        console.log('Log 3 triggered')
                        // check for special errors
                        if (res.msg === 'Invalid zip code' || res.msg === 'Missing parameters' || res.msg === 'You need to be 18 or older')
                            setShowError(res.msg)
                        else
                            setShowError('We are unable to process your data. Please check the infomation below is correct and resubmit.')

                        scrollToTop()
                    }

                }
            )

        } else {
            errorAlert('Fill the form')
        }
    }

    const sendToBuyers = (body) => {
        navigate(`/lead-array?contact_id=${body.contact_id}&source=ghl&page=nvsl${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid'])}`, { replace: true })
    }

    const checkForEmailNPass = () => {
        if (email.includes('@') && email.includes('.') && !email.includes('test')) {
            if (phone.length > 7 && phone !== '') {
                return {
                    success: true
                }
            } else {
                return {
                    success: false,
                    msg: 'Invalid phone number'
                }
            }
        } else {
            return {
                success: false,
                msg: 'Invalid email addresss'
            }
        }
    }

    const setUserAddress = (data) => {
        setZipcode(data.postalCode)
        setAddress(data.formatted.split(",")[0])
        setState(data.state)
        setCity(data.city)
        console.log(data)
    }




    useEffect(() => {
        scrollToTop()
        cookies.setCookies('mode', 'light', 10)
        dispatch(updatedarkmode({ dark: false }))

        const urlParams = new URLSearchParams(window.location.search)
        const contact_id = urlParams.get('contact_id')
        const first_name = urlParams.get('first_name')
        const trusted_cert_url = urlParams.get('trusted_form_cert_url')


        if (contact_id && first_name) {
            setContactId(contact_id)
            setFirstname(first_name)
            setTrustedCertUrl(trusted_cert_url)
            saveTrustedFormCert(trusted_cert_url, contact_id)
        }

        // eslint-disable-next-line
    }, [])


    return (
        <Mode>
            <MetaPixel pixelId="899779694725440" />
            <div className="form-page">
                {/* <TrustedCertUrl /> */}
                {/* <Toast open={open} setOpen={setOpen} severity={severity} timer={4000}>{msg}</Toast> */}
                {!contactId && !firstname && (
                    <Container>
                        <div className="margin-auto" style={{ maxWidth: '400px', padding: '10px' }}>
                            <Skeleton variant="rounded" width={"100%"} height={200} />
                            <Spacebox padding="10px" />
                            <Skeleton variant="rounded" width={100} height={15} />
                            <Spacebox padding="10px" />
                            <Skeleton variant="rounded" width="100%" height={10} />
                            <Spacebox padding="5px" />
                            <Skeleton variant="rounded" width="100%" height={10} />
                            <Spacebox padding="5px" />
                            <Skeleton variant="rounded" width="100%" height={10} />
                            <Spacebox padding="5px" />
                            <Skeleton variant="rounded" width="100%" height={10} />
                            <Spacebox padding="5px" />
                            <Skeleton variant="rounded" width="100%" height={10} />
                        </div>
                    </Container>
                )}
                {contactId && firstname && (
                    <div className="margin-auto mid bg">
                        {(step === 1) && <div className="margin-auto" style={{ padding: '20px' }}>
                            <img src="/assets/header-image.png" alt="couples-holding-phone" style={{ width: '100%', borderRadius: 20 }} />
                            <Spacebox padding="5px" />
                            {<span style={{ fontWeight: '700', fontSize: 30 }} className="text-primary heading bold">
                                <span className="text-black">{string.capitalise(firstname)},</span> Your <u>Options Are Ready</u></span>}
                            <Spacebox padding="15px" />
                            {<div>
                                {/* Content for GHL traffic */}
                                <span className="open-sans" style={{ opacity: .7 }}>
                                    <b className="bold">To provide you with options that are helping millions of American,</b> we've asked our debt relief  partners and affiliates to go over your evaluation.
                                    <br /><br />
                                    <b className="bold">To see your evaluation results online,</b> please complete the information below so we can confirm your qualifying debts and savings estimate.
                                </span>
                            </div>}
                            <Spacebox padding="5px" />
                            {/* Error message */}
                            {showError && <div>
                                <Alert severity={"error"}>
                                    {showError}
                                </Alert>
                            </div>}
                            {showFirstAndLastName && (
                                <div>
                                    <Spacebox padding="5px" />
                                    <Grid grid={2} gap='10px'>
                                        <div>
                                            <small style={{ fontSize: 14 }} className="open-sans text-primary"><b>First Name</b></small>
                                            <Spacebox padding="2px" />
                                            <input
                                                type="text"
                                                placeholder={firstname}
                                                value={first_name}
                                                onChange={(e) => setFirst_Name(e.target.value)}
                                            />
                                        </div>
                                        <div>
                                            <small style={{ fontSize: 14 }} className="open-sans text-primary"><b>Last Name</b></small>
                                            <Spacebox padding="2px" />
                                            <input
                                                type="text"
                                                placeholder=""
                                                value={last_name}
                                                onChange={(e) => setLast_Name(e.target.value)}
                                            />
                                        </div>
                                    </Grid>
                                    <Spacebox padding="10px" />
                                    <div>
                                        <small style={{ fontSize: 14 }} className="open-sans text-primary"><b>Email</b></small>
                                        <Spacebox padding="2px" />
                                        <input
                                            type="email"
                                            placeholder="Email address"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                        />
                                    </div>
                                    <Spacebox padding="10px" />
                                    <div>
                                        <small style={{ fontSize: 14 }} className="open-sans text-primary"><b>Phone</b></small>
                                        <Spacebox padding="2px" />
                                        <input
                                            type="tel"
                                            placeholder="Phone Number"
                                            value={phone}
                                            onChange={(e) => setPhone(e.target.value)}
                                        />
                                    </div>
                                </div>
                            )}
                            <Spacebox padding="5px" />
                            <small style={{ fontSize: 14 }} className="text-primary open-sans"><b>Address</b></small>
                            <Spacebox padding="2px" />
                            {/* <input
                                type="text"
                                placeholder="123 ABC Street"
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                            /> */}
                            <AddressAutocomplete
                                countries={["us"]} // optional: restrict to United State
                                onSelect={(data) => setUserAddress(data)}
                                value={inputAddress}
                                setValue={setInputAddress}
                            />
                            <Spacebox padding="10px" />
                            <div style={{ width: '50%' }}>
                                <small style={{ fontSize: 14 }} className="text-primary open-sans"><b>Date of Birth</b></small>
                                <Spacebox padding="2px" />
                                <Grid grid={4} gap="10px">
                                    <div>
                                        <input
                                            type="text"
                                            value={month}
                                            onChange={(e) => handleChange(e, setMonth)}
                                            onBlur={() => handleBlur(month, setMonth, 12)}
                                            inputMode="numeric"
                                            placeholder="01"
                                            maxLength={2}
                                            pattern="[0-9]{1,2}"
                                            style={{ textAlign: 'center' }}
                                        />
                                        <Spacebox padding="2px" />
                                        <div style={{ textAlign: 'center' }}>
                                            <small className="open-sans text-primary">Month (MM)</small>
                                        </div>
                                    </div>
                                    <div>
                                        <input
                                            type="text"
                                            value={day}
                                            onChange={(e) => handleChange(e, setDay)}
                                            onBlur={() => handleBlur(day, setDay, 31)}
                                            inputMode="numeric"
                                            placeholder="01"
                                            maxLength={2}
                                            pattern="[0-9]{1,2}"
                                            style={{ textAlign: 'center' }}
                                        />
                                        <Spacebox padding="2px" />
                                        <div style={{ textAlign: 'center' }}>
                                            <small className="open-sans text-primary">Day (DD)</small>
                                        </div>
                                    </div>
                                    <div style={{ gridColumn: '3/5' }}>
                                        <input
                                            type="text"
                                            value={year}
                                            onChange={(e) => handleChange(e, setYear)}
                                            onBlur={() => handleBlur(year, setYear, maxYear)}
                                            inputMode="numeric"
                                            placeholder="1979"
                                            maxLength={4}
                                            pattern="[0-9]{1,4}"
                                            style={{ textAlign: 'center' }}
                                        />
                                        <Spacebox padding="2px" />
                                        <div style={{ textAlign: 'center' }}>
                                            <small className="open-sans text-primary">Year <br /> (YYYY)</small>
                                        </div>
                                    </div>
                                </Grid>
                                <Spacebox padding="10px" />
                                <small style={{ fontSize: 14 }} className="text-primary open-sans"><b>Zip Code</b></small>
                                <Spacebox padding="2px" />
                                <input
                                    type="text"
                                    value={zipcode}
                                    onChange={(e) => {
                                        const digits = e.target.value.replace(/\D/g, '').slice(0, 9);
                                        const formatted = digits.length <= 5
                                            ? digits
                                            : `${digits.slice(0, 5)}-${digits.slice(5, 9)}`;
                                        setZipcode(formatted);
                                    }}
                                    inputMode="numeric"
                                    autoComplete="postal-code"
                                    pattern="^\d{5}(-\d{4})?$"
                                    maxLength={10}
                                    style={{ textAlign: 'center' }}
                                />
                            </div>
                            <Spacebox padding="5px" />
                            <NoticeText />
                            <Spacebox padding="5px" />
                            <Button
                                handleClick={() => {
                                    if (!loading)
                                        productOffer()
                                }}
                                className="signature-btn"
                                style={{ background: 'var(--secondary)', color: 'white', width: 'fit-content', padding: '10px 30px', borderRadius: '100px', fontSize: '1.1rem' }}
                            >
                                {!loading && "View Results Now"}
                                {loading && "Please wait..."}
                            </Button>
                            <Spacebox padding="10px" />
                            <Flexbox justifyContent="center">
                                <small className="terms" style={{ opacity: .5 }}>
                                    <b>We value your privacy.</b> By clicking the button above you consent to having your credit report accessed as explained underneath. This will not impact your credit. You understand that by clicking on the button above, you are providing written instructions to our <u>partner/ affiliates<span>TurboDebt, Clear One Advantage, Beyond Finance LLC, First Choice Debt Relief, National Debt Relief and Cura Debt</span></u> under the Fair Credit Reporting Act authorizing them to obtain information from your personal credit report or other information from a credit bureau solely for debt settlement.
                                </small>
                            </Flexbox>
                            <Spacebox padding="10px" />
                            <Flexbox justifyContent="center">
                                <img src="/assets/trustedSites.png" alt="trusted-site" style={{ width: 250, display: 'block', margin: 'auto' }} />
                            </Flexbox>
                            <Spacebox padding="20px" />
                        </div>}

                        {(step === 2 && severity === 'success') && <div>
                            {/* loading page */}
                            <Spacebox padding="20px" />
                            <div className="small margin-auto" style={{ textAlign: 'center' }}>
                                <span className="big-text">
                                    LOADING
                                </span>
                                <span style={{ fontWeight: '700' }} className="text-primary bold heading">Please, stand by...</span>
                                <Spacebox padding="10px" />
                                <div className="margin-auto" style={{ width: 'fit-content' }}>
                                    <Waveform size={40} speed={1.9} color={mode.dark ? "white" : "black"} />
                                </div>
                                <Spacebox padding="10px" />
                                <span style={{ fontSize: 20 }}>Stand by while we pull together:</span>
                                <Spacebox padding="5px" />
                                <div>
                                    {loading_texts.map((text, i) => (
                                        <Flexbox alignItems="center" key={i} style={{ marginBottom: '10px' }}>
                                            <Waveform size={25} speed={1.9} color={mode.dark ? "white" : "black"} />
                                            <Spacebox padding="10px" />
                                            <span style={{ fontSize: 20 }}>{text}</span>
                                        </Flexbox>
                                    ))}
                                </div>
                            </div>
                        </div>}

                        {(step === 2 && severity === 'error' && user) && <div>
                            {/* Failed page */}
                            <div className="margin-auto error-div" style={{ textAlign: 'center', padding: 20 }}>
                                <Spacebox padding="20px" />
                                <Flexbox alignItems="center" justifyContent="center">
                                    <img src="/assets/color-logo.png" alt="final debt Relief" style={{ width: 200 }} />
                                </Flexbox>
                                <Spacebox padding="10px" />
                                <Flexbox justifyContent="space-between" alignItems="center">
                                    <div>
                                        <span>
                                            Name: <b>{user.first_name} {user.last_name}</b>
                                        </span>
                                        <Spacebox padding="0px" />
                                        <span>
                                            Date: <b>{(new Date()).toString().substring(4, 16)}</b>
                                        </span>
                                    </div>
                                    <div></div>
                                </Flexbox>
                                <Spacebox padding="20px" />
                                <div className="margin-auto" style={{ textAlign: 'center', maxWidth: 500, padding: 10 }}>
                                    <span>
                                        We're sorry, there was a problem trying to access your results. A Consolidation Specialist from {user.debt_amount > 20000 ? 'Accredited Debt Relief' : 'Turbo Debt'} will call to go over your qualifying debts, savings estimate and available options.
                                        <br /><br />
                                        <b className="trade-red">
                                            For Immediate help your may also reach out directly at <a className="trade-red" href="tel:+18552195423">(855) 219-5423.</a>
                                        </b>
                                    </span>
                                    <Spacebox padding="10px" />
                                    <div style={{ borderRadius: 20, height: 10, overflow: 'hidden' }} className="bg-shade">
                                        <div style={{ background: 'var(--primary)', width: '40%', height: 10 }}></div>
                                    </div>
                                    <Spacebox padding="20px" />
                                </div>
                            </div>
                        </div>}

                        {(step === 3 && severity === 'success' && user) && (
                            <div>

                                {/* THANK YOU PAGE FOR BUYER A */}
                                {(user.debt_amount > 20000 && trial < 2) && (
                                    <BuyerATYP user={user} url={redirectUrl} />
                                )}

                                {/* THANK YOU PAGE FOR BUYER B and C */}
                                {(user.debt_amount < 20000 || trial > 2) && (
                                    <BuyerBnCTYP user={user} url={redirectUrl} />
                                )}
                            </div>
                        )}
                    </div>
                )}
            </div>
        </Mode>
    );
}

export default FormPageNVSL;
